module.exports = __webpack_public_path__ + "img/c01_unitstartechchainmail_Normal_ua.b7181237.webp";